import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { Job } from "@/models/Job.model";
import { useJobListingStore } from "@/store/jobs/jobs.store";

export const useJobs = (status: "draft" | "published" | "archived") => {
  const { jobListings, setJobListings } = useJobListingStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);

    try {
      await collectionRef.Jobs.where("status", "==", status)
        .get()
        .then((querySnapshot) => {
          const data: Job[] = [];
          querySnapshot.forEach((doc) => {
            const variation = doc.data() as Job;
            const job = {
              ...variation,
              id: doc.id,
            } as Job;
            data.push(job);
          });
          setJobListings(data);
          setLoading(false);
        });
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!jobListings) {
      fetchData();
    }
  }, [jobListings]);

  return {
    data: jobListings,
    loading,
    error,
  };
};
